'use client'

import dynamic from 'next/dynamic'
import s from './embedded-video.module.css'

const ReactPlayer = dynamic(() => import('react-player/lazy'), {
  ssr: false,
})

type Props = {
  url?: string
}

export const EmbeddedVideoBlock = ({ url }: Props) => {
  if (!url) return <p>Embedded Video Block</p>

  return (
    <div className={s.container}>
      <div className={s.wrapper}>
        <ReactPlayer
          url={url}
          width="100%"
          height="100%"
          controls
          config={{ vimeo: { playerOptions: { responsive: true } } }}
        />
      </div>
    </div>
  )
}
